export const Colors = {
    mainColor: "#00B06E",
    whiteColor: "#ffffff",
    textColor: "#6d6d6d",
    textSubColor: "#333333"
}

